module.exports = __webpack_public_path__ + "static/media/backArrow.fd84efcd.svg";